/** Which surface the user is on: the prospected page, or the Search tab. */
export const APP_CONTEXT = {
    PROSPECT: 'PROSPECT',
    SEARCH: 'SEARCH',
};
const appTypes = {
    RESET: 'APP/RESET',
    PAGE_CHANGED: 'PAGE_CHANGED',
};
export default appTypes;
